import { Box, Stack, Typography } from '@mui/material';
import { DesktopTimePicker } from '@mui/x-date-pickers/DesktopTimePicker';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import Icon from 'components/Icon';
import dayjs from 'dayjs';
import React, { useContext, useState } from 'react';
import { CartContext } from 'constants/contexts';
import CateringMenuHours from './CateringMenuHours';
import './index.css';

function DateTimePicker({
  value, onChange, variant = 'default', hasError,
}) {
  const [openDatePicker, setOpenDatePicker] = useState(false);
  const [openTimePicker, setOpenTimePicker] = useState(false);
  const cart = useContext(CartContext);
  function getMinDate() {
    if (cart.firstAvailableTime) {
      return dayjs(cart.firstAvailableTime);
    } if (cart.merchant?.minimum_scheduling_hours) {
      return dayjs(dayjs().valueOf() + (cart.merchant.minimum_scheduling_hours * (60 * 60 * 1000)));
    }
    return dayjs();
  }
  function getMinTime() {
    const selectedDate = dayjs(value);
    const today = dayjs();
    const firstAvailableTime = dayjs(cart.firstAvailableTime);
    // If selected date is today, return current time
    if (selectedDate.isSame(today, 'day') || selectedDate.isSame(firstAvailableTime, 'day')) {
      return getMinDate();
    }
  }

  return (
    <Box display="flex" flexDirection="column">
      {hasError && (
        <Box sx={{
          backgroundColor: 'background.error', p: 2, mb: { md: 2 }, borderRadius: variant === 'default' ? { xs: 0, md: 3 } : 3,
        }}
        >
          <Typography variant="title-md">
            First available scheduling time:
            {' '}
            {dayjs(cart.firstAvailableTime).format('ddd, MMMM D, hh:mm a')}
          </Typography>
          <Typography variant="body-md">
            {cart.merchant?.name}
            {' '}
            is closed at this time, Please choose a different time.
          </Typography>
        </Box>
      )}

      <Box display="flex" flexDirection="column" gap={2} p={{ xs: variant === 'default' ? 2 : '16px 0 0', md: 0 }}>
        <CateringMenuHours />

        <Typography variant="body-md">
          Your order is scheduled for delivery on this date at this time.
        </Typography>

        <Stack spacing={2} data-testid="date-and-time">
          <DesktopDatePicker
            value={dayjs(value)}
            onChange={onChange}
            format="dddd, MMMM D"
            sx={{
              width: '100%',
              '& input': { fontWeight: 700, fontSize: 14, color: hasError ? 'error.main' : 'inherit' },
            }}
            disabled={cart.menuLoading}
            minDate={getMinDate()}
            open={openDatePicker}
            onOpen={() => setOpenDatePicker(true)}
            onClose={() => setOpenDatePicker(false)}
            slots={{ openPickerIcon: () => <Icon name="calendar-outlined" color={hasError ? 'error.main' : 'text.primary'} /> }}
            slotProps={{
              textField: {
                placeholder: 'Date',
                onClick: () => setOpenDatePicker(true),
                focused: false,
                readOnly: true,
                error: hasError,
              },
            }}
          />
          <DesktopTimePicker
            value={dayjs(value)}
            onChange={onChange}
            open={openTimePicker}
            onOpen={() => setOpenTimePicker(true)}
            onClose={() => setOpenTimePicker(false)}
            sx={{
              width: '100%',
              '& input': { fontWeight: 700, fontSize: 14, color: hasError ? 'error.main' : 'inherit' },
            }}
            disabled={cart.menuLoading}
            minTime={getMinTime()}
            timeSteps={{ hours: 1, minutes: 15 }}
            slots={{ openPickerIcon: () => <Icon name="clock-outlined" color={hasError ? 'error.main' : 'text.primary'} /> }}
            slotProps={{
              textField: {
                placeholder: 'Time',
                onClick: () => setOpenTimePicker(true),
                focused: false,
                readOnly: true,
                error: hasError,
              },
            }}
          />
        </Stack>
      </Box>
    </Box>
  );
}

export default DateTimePicker;
